import { EnvironmentProviders, Provider } from '@angular/core';
import { SOFTLINE_CONFIG_PREVIEW_HANDLER } from '@softline/ui-core';
import { ArchivePdfPreviewHandler } from './services/archive-pdf-preview.handler';

export const pdfViewerProviders: Array<Provider | EnvironmentProviders> = [
  {
    provide: SOFTLINE_CONFIG_PREVIEW_HANDLER,
    useClass: ArchivePdfPreviewHandler,
    multi: true,
  },
];
